<ng-container *ngIf="dashboardDataGql$ | async as dashboardData">
  <div class="tile-head flex-row flex-vertical-center">
    <cigna-icon
      class="dashboard-icon"
      [type]="appContext === 'evernorth' ? 'evernorth-person' : 'lock'"
    ></cigna-icon>
    <h3 class="cg-h3">{{ 'dashboard.manageAccessTile.header' | translate }}</h3>
  </div>

  <ng-container *ngIf="dashboardData.errors; else hasData">
    <div class="tile-section flew-row empty-state-stlying">
      <div data-test="error-msg" class="cg-error-msg-large">
        <cigna-icon type="exclamation-circle"></cigna-icon>
        <div>
          <div>{{ 'shared.common.serviceError' | translate }}</div>
          <div
            *ngIf="dashboardData.errors[0]?.message"
            class="cg-margin-top-md"
          >
            {{ dashboardData.errors[0].message }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #hasData>
    <ng-container
      *ngIf="
        dashboardData.loading &&
        dashboardData.data.wamDashboardUsers.users.length === 0
      "
    >
      <div class="cg-flex-center cg-margin-top-lg cg-margin-bottom-lg">
        <div class="cg-spinner"></div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        dashboardData.loading === false &&
        dashboardData.data.wamDashboardUsers.users.length > 0
      "
    >
      <section class="users-list">
        <table class="cg-datatable tile-table">
          <thead data-test="users-list-header">
            <tr data-test="users-table-header">
              <th style="width: 270px" class="cg-datatable__header">
                <div
                  class="nosort-header-container"
                  data-test="user-name-header"
                >
                  User
                </div>
              </th>
              <th class="cg-datatable__header">
                <div
                  class="nosort-header-container"
                  data-test="user-jobrole-header"
                >
                  Job role
                </div>
              </th>
              <th class="cg-datatable__header">
                <div
                  class="nosort-header-container"
                  data-test="user-tins-header"
                >
                  TINs
                </div>
              </th>
              <th class="cg-datatable__header" style="width: 130px">
                <div
                  class="nosort-header-container"
                  data-test="user-status-header"
                >
                  Status
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              data-test="users-table-body"
              *ngFor="let user of dashboardData.data.wamDashboardUsers.users"
            >
              <td class="cg-datatable__cell" style="vertical-align: top">
                <div class="cg-flex cg-flex-vertical-center">
                  <div class="checkbox-column">
                    <input
                      [attr.aria-label]="'select user ' + user.lastName"
                      type="checkbox"
                      data-test="wam-user-checkbox"
                      (change)="onUserCheck(user.id, $event)"
                    />
                  </div>
                  <div class="user-section">
                    <button
                      cignaButton="link"
                      data-test="wam-user-name-link"
                      class="cg-flush-button-link cg-font-size-m wrapped-text"
                      (click)="viewUserDetail(user)"
                    >
                      <strong data-test="user-name"
                        >{{ user.lastName }}, {{ user.firstName }}</strong
                      >
                    </button>
                    <div class="cg-margin-bottom-sm">
                      <div
                        class="cg-margin-bottom-xs wrapped-text"
                        data-test="user-ssoid"
                      >
                        <ng-container
                          *ngIf="user.temporaryUserName && !user.ssoId"
                          >{{ user.temporaryUserName }} (Temp User
                          ID)</ng-container
                        >
                        <ng-container *ngIf="user.ssoId">{{
                          user.id
                        }}</ng-container>
                      </div>
                      <div
                        class="cg-margin-bottom-xs wrapped-text"
                        data-test="user-ssoid-password"
                        *ngIf="user.temporaryPassword && !user.ssoId"
                      >
                        {{ user.temporaryPassword }} (Temp Password)
                      </div>
                      <div
                        class="cg-margin-bottom-xs wrapped-text"
                        data-test="user-email"
                      >
                        {{ user.email }}
                      </div>
                      <div
                        class="cg-margin-bottom-xs"
                        data-test="user-phone"
                        *ngIf="user.phone"
                      >
                        {{ user.phone | phoneNumber }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td class="cg-datatable__cell" style="vertical-align: top">
                <div class="content-padding" data-test="user-job-role">
                  {{ user.jobRole }}
                </div>
              </td>

              <td class="cg-datatable__cell" style="vertical-align: top">
                <div class="content-padding">
                  <div
                    *ngFor="let tin of renderTins(user.tins)"
                    class="cg-margin-bottom-md"
                  >
                    <div data-test="user-tin">{{ tin.tin }}</div>
                    <div class="cg-font-size-s wrapped-text">
                      <i data-test="user-tin-name">{{ tin.name }}</i>
                    </div>
                  </div>
                </div>
              </td>
              <td class="cg-datatable__cell" style="vertical-align: top">
                <div class="warn-section content-padding">
                  <div>
                    <cigna-icon
                      class="cg-icon-lg cg-color-warn"
                      type="exclamation-triangle"
                    ></cigna-icon>
                  </div>
                  <div data-test="user-status">
                    {{ 'dashboard.manageAccessTile.awaitingNote' | translate }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="button-area">
        <button
          cignaButton="link"
          [disabled]="!modifyButtonEnabled"
          data-test="wam-modify-selected-button"
          (click)="onModifySelectedUsers()"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Modify selected users',
            'ac-DB009-Modify Selected',
            {
              eVar101: 'Manage User Access:Edit User'
            }
          ]"
        >
          {{ 'dashboard.manageAccessTile.modifyLink' | translate }}
        </button>
        <div style="margin-left: auto">
          <cigna-pagination
            [boundaryLinks]="true"
            [itemsPerPage]="itemsPerPage"
            [disabled]="dashboardData.loading"
            [currentPage]="currentPage"
            [totalItems]="dashboardData.data.wamDashboardUsers.total"
            (pageChanged)="handlePagination($event)"
            [useChevron]="true"
          >
          </cigna-pagination>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        dashboardData.loading === false &&
        dashboardData.data.wamDashboardUsers.users.length === 0
      "
    >
      <div class="tile-section flew-row empty-state-stlying">
        <p data-test="no-users">
          {{ 'dashboard.manageAccessTile.noUsers' | translate }}
        </p>
        <a routerLink="/my-practice/manage-access"
          ><strong>Manage existing users</strong></a
        >
      </div>
    </ng-container>
  </ng-template>
</ng-container>
